// GENERATED by tools/levels (pnpm levels:build). Do not edit by hand.
import type { ArcadePack } from "./schema.ts";

export const ARCADE_CONTENT_VERSION = "arcade-1.0.0";

/** sha256 of each frozen chapter pack, checked by `pnpm levels:check`. */
export const ARCADE_PACK_SHA256: Readonly<Record<number, string>> = {
  1: "dc51eb7b2c6c43388bbf14fe1c7dfbba71c36a73152014b2fa0e0e91d7c9b6d7",
  2: "fd1cba66efcc8daf9219da28577f3c56fb7c48e8451f28559a4b43ffc333315d",
  3: "ac34f56f4b8a9019be0eca8287f292cba4e0d0f9c75bec06139e2cad678af06c",
  4: "e15e4af3008ad75ce0fbfdb41d112168d3ce3e76e29a7598b40f8ffd7bccf478",
  5: "3123c78a096d7edea78255b1f82fca2d1a064fc493f4cb6fbfb79d27fcb3c51c",
  6: "93686f12e2b709f0941e2a9d811b3849ec16ea0d1ed2aca786d70dc33bd81e7d",
  7: "0ee65b6b8b09fe6d26a21e0790c9817c238ffa438a79a922519c3d7ca4cae856",
  8: "abc72b6c140f63ba4d34b66d9d67e4ba190c61c30b4bba8c97f90105399791d2",
  9: "f4f1eccd052a8edf59197d0cc5970c17a96d0de66a8ef2c23f890aa71483ba31",
  10: "8e04c4b21b9f7394c734f03b89c1213d07aac0048d27c0bcd3f2dd05e450fa09",
};

/** Lazy loaders: the client only downloads the chapter being played. */
export const ARCADE_PACK_LOADERS: Readonly<Record<number, () => Promise<ArcadePack>>> = {
  1: () => import("../../packs/arcade/arcade-1.0.0/chapter-01.json").then((m) => m.default as ArcadePack),
  2: () => import("../../packs/arcade/arcade-1.0.0/chapter-02.json").then((m) => m.default as ArcadePack),
  3: () => import("../../packs/arcade/arcade-1.0.0/chapter-03.json").then((m) => m.default as ArcadePack),
  4: () => import("../../packs/arcade/arcade-1.0.0/chapter-04.json").then((m) => m.default as ArcadePack),
  5: () => import("../../packs/arcade/arcade-1.0.0/chapter-05.json").then((m) => m.default as ArcadePack),
  6: () => import("../../packs/arcade/arcade-1.0.0/chapter-06.json").then((m) => m.default as ArcadePack),
  7: () => import("../../packs/arcade/arcade-1.0.0/chapter-07.json").then((m) => m.default as ArcadePack),
  8: () => import("../../packs/arcade/arcade-1.0.0/chapter-08.json").then((m) => m.default as ArcadePack),
  9: () => import("../../packs/arcade/arcade-1.0.0/chapter-09.json").then((m) => m.default as ArcadePack),
  10: () => import("../../packs/arcade/arcade-1.0.0/chapter-10.json").then((m) => m.default as ArcadePack),
};
